import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

// path is what user type in the browser url.
// component: is where is routes to
// For example, if the user type: http://localhost, it will routes to "Home" component

// the difference between "component" vs "component" function ...
// When building apps with a bundler, the JavaScript bundle can become quite large,
// and thus affect the page load time.It would be more efficient if we can split each route's
// components into a separate chunk, and only load them when the route is visited.

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/About.vue");
    }
  },
  {
    path: "/students",
    name: "Students",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "students" */ "../views/Students.vue");
    }
  },
  {
    path: "/bitcoin",
    name: "Bitcoin",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "bitcoin" */ "../views/Bitcoin.vue");
    }
  },
  {
    path: "/todolist",
    name: "ToDoList",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "todolist" */ "../views/ToDoList.vue");
    }
  },
  {
    path: "/todolistapi",
    name: "ToDoListApi",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(
        /* webpackChunkName: "todolistapi" */ "../views/ToDoListApi.vue"
      );
    }
  },
  {
    path: "/ecommerce",
    name: "ECommerce",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(
        /* webpackChunkName: "ecommerce" */ "../views/ECommerce.vue"
      );
    }
  },
  {
    path: "/currency",
    name: "Currency",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "currency" */ "../views/Currency.vue");
    }
  },
  {
    path: "/battle",
    name: "Battle",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "battle" */ "../views/Battle.vue");
    }
  },
  {
    path: "/calculator",
    name: "Calculator",
    // lazy-loaded when the route is visited.
    component: function() {
      return import(
        /* webpackChunkName: "calculator" */ "../views/Calculator.vue"
      );
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
